/** 생산 요청을 처리하는 동안 화면을 잠그고, 응답을 받지 못한 경우를 안내한다. */
const NO_RESPONSE_MESSAGE =
  "서버 응답을 받지 못했습니다. 처리되었을 수 있으니 목록을 확인해 주세요.";

// 여러 폼이 동시에 요청해도 모든 요청이 끝난 뒤에 화면 잠금을 푼다.
let lockCount = 0;
let loading = null;

function acquireLock(self, text) {
  lockCount++;
  if (lockCount === 1) {
    loading = self.$loading({
      lock: true,
      text: text,
      background: "rgba(0, 0, 0, 0.5)",
    });
  }
}

/** 잠금 화면을 만들지 못했거나 닫다가 예외가 나도 공유 상태는 되돌린다. */
function releaseLock() {
  lockCount--;
  if (lockCount === 0 && loading) {
    const opened = loading;
    loading = null;
    opened.close();
  }
}

export const production_process = {
  data() {
    return {
      processing: false,
    };
  },
  methods: {
    /**
     * 처리 중에 다시 호출되면 요청하지 않는다.
     * 화면 처리(잠금, 알림, 콜백)에서 난 예외는 감추지 않고 그대로 던진다.
     * @param {잠금 화면 문구} text
     * @param {요청 함수() => Promise} request
     * @param {success(res): 성공 응답 처리, error(res): 오류 응답 처리(생략 시 오류 알림),
     *         always(): 처리 중 재호출이 아니면 성공·오류·무응답·화면 처리 예외와 관계없이
     *         마지막에 한 번 실행. 잠금 화면을 만들지 못해 요청하지 않은 경우도 포함} handlers
     */
    async processProduction(text, request, handlers) {
      if (this.processing) {
        return;
      }
      const { success, error, always } = handlers;
      this.processing = true;
      // 잠금 화면을 만들지 못하면 요청하지 않는다.
      let requested = false;
      let res;
      try {
        acquireLock(this, text);
        requested = true;
        try {
          res = await request();
        } catch (e) {
          res = { error: 1, message: NO_RESPONSE_MESSAGE };
        }
      } finally {
        this.processing = false;
        try {
          releaseLock();
        } finally {
          try {
            if (requested) {
              this.handleProductionResponse(res, success, error);
            }
          } finally {
            if (always) {
              always();
            }
          }
        }
      }
    },
    handleProductionResponse(res, success, error) {
      if (res.error !== this.system.noError) {
        if (error) {
          error(res);
        } else {
          this.util.notify_response_error(this, this.title, res);
        }
      } else if (success) {
        success(res);
      }
    },
  },
};
